const EMPTY_OUTCOME_LIST = [""];

export const EMPTY_APPROVAL = {
  project_name: "",
  objective: "",
  duration_months: 12,
  start_date: "",
  end_date: "",
  convocatoria: "",
  presupuesto_total: 0,
  socios: "",
  financial: {
    presupuesto: 0,
    ayuda: 0,
    prestamo: 0,
    subvencion: 0,
    deduccion_fiscal: 0,
    ahorro_financiero: 0,
  },
  costs: {
    mano_obra: 0,
    colaboraciones: 0,
    equipos: 0,
    material_fungible: 0,
    auditoria: 0,
    otros: 0,
  },
  success_outcomes: EMPTY_OUTCOME_LIST,
  notes: "",
  rd_project_id: null,
  attached_document_ids: [],
};

export const STATUS_LABELS = {
  draft: { label: "Borrador", color: "bg-slate-100 text-slate-700 border-slate-300" },
  pending_signature: { label: "Pendiente de firma", color: "bg-amber-100 text-amber-700 border-amber-300" },
  approved: { label: "Aprobado", color: "bg-green-100 text-green-700 border-green-300" },
  rejected: { label: "Rechazado", color: "bg-red-100 text-red-700 border-red-300" },
};

export function fmtEUR(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}
